import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CustomCard from "../../../UI/CustomCard/CustomCard";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import useService from "../../../Hooks/useService";
import CampaignService from "../../../../Services/Campaign.service";
const CampaignTypeInfo = ({ actionId, campaignId }) => {
    const [actionState, loadAction] = useService(CampaignService.getAction);
    const [infoState, loadInfo] = useService(CampaignService.getCampaignTypeInfo);
    React.useEffect(() => {
        loadAction(actionId);
    }, [actionId, loadAction]);
    React.useEffect(() => {
        loadInfo(actionId, campaignId);
    }, [actionId, campaignId, loadInfo]);
    return (_jsx(CustomCard, { title: "Type Info", children: _jsx("div", { className: "card-body", children: _jsx(ServiceResult, { state: actionState, children: (action) => (_jsx(ServiceResult, { state: infoState, children: (info) => (_jsx("div", { className: "row", children: [{ label: "Type", value: action.name }]
                            .concat(info)
                            .map((item, i) => (_jsx("div", { className: "col-6", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { children: item.label }), _jsx("div", { children: item.value })] }) }, i))) })) })) }) }) }));
};
export default CampaignTypeInfo;
